import { Button, Modal, ModalBody } from 'reactstrap'
import { useTranslation } from 'react-i18next'

interface ErrorModalProps {
    show: boolean
    title: string
    text?: string
    children?: React.ReactNode
    onCloseClick: () => void
}

const ErrorModal = (props: ErrorModalProps) => {
    const { t } = useTranslation()
    const { show, title, text, children, onCloseClick } = props

    return (
        <Modal isOpen={show} toggle={onCloseClick}>
            <ModalBody className="py-3 px-5">
                <div className="mt-2 text-center">
                    <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                        <h4>{title}</h4>
                        {children ? children : <p className="text-muted mx-4 mb-0">{text}</p>}
                    </div>
                </div>
                <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                    <Button type="button" color="primary" data-bs-dismiss="modal" onClick={onCloseClick}>
                        {t('form.modal.error.button.ok')}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default ErrorModal
